const VIDEO_PROVIDER = {
  YOUTUBE: 'youtube',
  VIMEO: 'vimeo'
};

export default VIDEO_PROVIDER;
